import { useQuery } from "@tanstack/react-query";
import { fetchEcommSales, type EcommSalesRawResponse } from "../services/ecommSalesService";

export const useEcommSales = (startDate: string, endDate: string) => {
  return useQuery<EcommSalesRawResponse>({
    queryKey: ["ecomm-sales-dashboard", startDate, endDate],
    queryFn: () => fetchEcommSales(startDate, endDate),
    staleTime: 1000 * 60 * 5, 
  });
};
